import BaseAction from '../../base-action'
import { fetchContentIfNeeded } from '../../content'

const resource = 'offers'
const verb = 'put'

export default class OspreyOffersBatchUpdate extends BaseAction {
    constructor(dataKey) {
        const id = 'b9268723-4a3f-4792-be96-daf42b8353b3'
        const path = `/${resource}`
        super(resource, verb, path, id, dataKey)
        this.noCache = true
    }

    batchUpdate(offer) {
        if (!offer) {
            throw new Error('Missing offer object')
        }

        this.params = {
            offer
        }

        return fetchContentIfNeeded(this)
    }
}


// WEBPACK FOOTER //
// src/actions/osprey-api/offers/offers-batch-update.js